import { CheckboxField, SelectField } from '@ets-global/b2c-website-ui';
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

import BaseModal from '../../components/Base/Modal/BaseModal';
import { ARTICLE_FAMILIES } from '../../constants';
import { slugifyTestTypeFamilyName } from '../../helpers/buyingProcess';
import { setParam } from '../../helpers/router';
import ModalContext from '../../store/Modal/ModalContext';

const Filters = ({ filters = new Map(), testTypeFamilies = [] }) => {
  const history = useHistory();
  const { showModal, hideModal } = useContext(ModalContext);
  const { t } = useTranslation();

  const testTypeFamiliesOptions = [
    { label: t('prep-tool.filter.testtype.all'), value: 'all' },
    ...testTypeFamilies.map((testTypeFamilyName) => ({
      label: testTypeFamilyName,
      value: slugifyTestTypeFamilyName(testTypeFamilyName),
    })),
  ];
  const currentTestTypeFamilyName = testTypeFamilies.find((testTypeFamilyName) =>
    [testTypeFamilyName, slugifyTestTypeFamilyName(testTypeFamilyName)].includes(filters.get('testTypeFamilyName'))
  );

  const updateURL = ({ key, value }) => {
    if (
      value === false &&
      ((!filters.get(ARTICLE_FAMILIES.ONLINE) && key === ARTICLE_FAMILIES.BOOK) ||
        (!filters.get(ARTICLE_FAMILIES.BOOK) && key === ARTICLE_FAMILIES.ONLINE))
    ) {
      return showModal(BaseModal, {
        isOpen: true,
        onClose: hideModal,
        children: <Trans>prep-tool.filter.error-no-filter</Trans>,
        className: 'modal__container--small',
      });
    }
    history.push({
      search: setParam({
        search: history.location.search,
        key,
        value: value.toString(),
      }),
    });
  };

  return (
    <div className="prep-tools-list__filters">
      <p className="prep-tools-list__filters-title">
        <Trans>prep-tool.filter-title</Trans>
      </p>
      <div className="prep-tools-list__filters-fields">
        <div className={'field-wrapper field-wrapper--select'}>
          <SelectField
            name={'testTypeFamilyName'}
            value={currentTestTypeFamilyName ? slugifyTestTypeFamilyName(currentTestTypeFamilyName) : undefined}
            onChange={(e) => updateURL({ key: 'testTypeFamilyName', value: e.target.value })}
            options={testTypeFamiliesOptions}
          />
        </div>
        <CheckboxField
          label={<Trans>prep-tool.online-tools.title</Trans>}
          id={ARTICLE_FAMILIES.ONLINE}
          name={ARTICLE_FAMILIES.ONLINE}
          value={filters.get(ARTICLE_FAMILIES.ONLINE)}
          onChange={() =>
            updateURL({
              key: ARTICLE_FAMILIES.ONLINE,
              value: !filters.get(ARTICLE_FAMILIES.ONLINE),
            })
          }
        />
        <CheckboxField
          label={<Trans>prep-tool.books.title</Trans>}
          id={ARTICLE_FAMILIES.BOOK}
          name={ARTICLE_FAMILIES.BOOK}
          value={filters.get(ARTICLE_FAMILIES.BOOK)}
          onChange={() =>
            updateURL({
              key: ARTICLE_FAMILIES.BOOK,
              value: !filters.get(ARTICLE_FAMILIES.BOOK),
            })
          }
        />
      </div>
    </div>
  );
};

Filters.propTypes = {
  filters: PropTypes.instanceOf(Map),
  testTypeFamilies: PropTypes.array,
};

export default Filters;
